import BaseFragmentSerializer from '@square/dashboard-data/serializers/fragment';
export default BaseFragmentSerializer.extend({
  attrs: {
    itemVariationId: {
      key: 'catalog_object_id'
    },
    itemId: {
      key: 'catalog_item_id'
    }
  },
  serializeAttribute(snapshot, json, key, attribute) {
    if (attribute.options && attribute.options.readOnly) {
      return;
    }
    this._super(snapshot, json, key, attribute);
  }
});